import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100c0515"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "A empresa possui programa formal de manutenção preventiva ?"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "",
  title: "Observações"
}
const _hoisted_8 = { class: "ant-row ui-espaco-campos" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "",
  title: "Quais tipos de manutenção são adotados?"
}
const _hoisted_11 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"margin-top":"15px","display":"flex","align-items":"center"} }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  class: "",
  title: "Observações"
}
const _hoisted_16 = { class: "ant-row ui-espaco-campos" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = {
  class: "",
  title: "O local apresenta vulnerabilidade a incêndios florestais ou vandalismo?"
}
const _hoisted_19 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  class: "",
  title: "Observações"
}
const _hoisted_22 = { class: "ant-row ui-espaco-campos" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_24 = {
  class: "",
  title: "Existe um Plano Formal de Continuidade de Negócios (PCN)?"
}
const _hoisted_25 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  class: "",
  title: "Observações"
}
const _hoisted_28 = { class: "ant-row ui-espaco-campos" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_30 = {
  class: "",
  title: "Existe um Plano Formal de Trabalho de Permissão de trabalho a quente?"
}
const _hoisted_31 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  class: "",
  title: "Observações"
}
const _hoisted_34 = { class: "ant-row ui-espaco-campos" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_36 = {
  class: "",
  title: "Qual é a estimativa de impacto financeiro decorrente de lucros cessantes nos cenários de interrupção de:"
}
const _hoisted_37 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "6 meses:", -1))
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "12 meses:", -1))
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = {
  class: "",
  title: "Observações"
}
const _hoisted_48 = { class: "ant-row ui-espaco-campos" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_50 = {
  class: "",
  title: "Valor estimado de produtos em estoque. matéria prima para processo produtivo?"
}
const _hoisted_51 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Valor", -1))
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Data", -1))
const _hoisted_58 = { key: 2 }
const _hoisted_59 = {
  class: "",
  title: "Observações"
}
const _hoisted_60 = { class: "ant-row ui-espaco-campos" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_62 = {
  class: "",
  title: "Valor estimado dos produtos acabados em estoque"
}
const _hoisted_63 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "ant-row" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Valor", -1))
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Data", -1))
const _hoisted_70 = { key: 2 }
const _hoisted_71 = {
  class: "",
  title: "Observações"
}
const _hoisted_72 = { class: "ant-row ui-espaco-campos" }
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_74 = {
  class: "",
  title: "Houve sinistros durante a vigência do seguro atual?"
}
const _hoisted_75 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_76 = { key: 1 }
const _hoisted_77 = {
  class: "",
  title: "Observações"
}
const _hoisted_78 = { class: "ant-row ui-espaco-campos" }
const _hoisted_79 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_80 = {
  class: "",
  title: "Existe histórico de vendavais, granizo ou eventos climáticos severos nos últimos 3 anos?"
}
const _hoisted_81 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  class: "",
  title: "Observações"
}
const _hoisted_84 = { class: "ant-row ui-espaco-campos" }
const _hoisted_85 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_86 = {
  class: "",
  title: "Existem vizinhos que apresentem riscos à operação?"
}
const _hoisted_87 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_88 = { key: 1 }
const _hoisted_89 = {
  class: "",
  title: "Observações"
}
const _hoisted_90 = { class: "ant-row ui-espaco-campos" }
const _hoisted_91 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_92 = {
  class: "",
  title: "Observações gerais da inspeção:"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 7 – MANUTENÇÃO, RISCOS, HISTÓRICOS",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.programaManutencaoPreventivaVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao7.programaManutencaoPreventivaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.programaManutencaoPreventivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.programaManutencaoPreventivaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.programaManutencaoPreventivaEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao7.programaManutencaoPreventivaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.programaManutencaoPreventivaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" A empresa possui programa formal de manutenção preventiva ? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('programaManutencaoPreventiva')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.programaManutencaoPreventivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.programaManutencaoPreventiva,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedSecao7.programaManutencaoPreventiva = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.programaManutencaoPreventivaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.programaManutencaoPreventiva,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computedSecao7.programaManutencaoPreventiva = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.programaManutencaoPreventiva)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.programaManutencaoPreventiva), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.programaManutencaoPreventivaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.programaManutencaoPreventivaObservacoesVisivel,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao7.programaManutencaoPreventivaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.programaManutencaoPreventivaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.programaManutencaoPreventivaObservacoes,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSecao7.programaManutencaoPreventivaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.manutencaoTipoVisivel,
                        "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.manutencaoTipoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.manutencaoTipoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.manutencaoTipoEnviarEmail,
                            "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.manutencaoTipoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Quais tipos de manutenção são adotados? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('manutencaoTipo')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.manutencaoTipo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ManualPreenchimentoInspecao.manutencaoTipo), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao7.manutencaoTipoVisivel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao7.manutencaoTipoCorretiva,
                          "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoCorretiva) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Corretiva")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao7.manutencaoTipoPreventiva,
                          "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoPreventiva) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Preventiva")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao7.manutencaoTipoPreditiva,
                          "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoPreditiva) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Preditiva")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.manutencaoTipoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.manutencaoTipoObservacoesVisivel,
                              "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.manutencaoTipoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.manutencaoTipoObservacoes,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedSecao7.manutencaoTipoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel,
                        "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoEnviarEmail,
                            "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" O local apresenta vulnerabilidade a incêndios florestais ou vandalismo? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('vulnerabilidadeIncendiosFlorestaisVandalismo')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismo,
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismo = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismo,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismo = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.vulnerabilidadeIncendiosFlorestaisVandalismo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.ManualPreenchimentoInspecao.vulnerabilidadeIncendiosFlorestaisVandalismo), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoObservacoesVisivel,
                              "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoObservacoes,
                            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedSecao7.vulnerabilidadeIncendiosFlorestaisVandalismoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.possuiPcnVisivel,
                        "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedSecao7.possuiPcnVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.possuiPcnVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.possuiPcnEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.possuiPcnEnviarEmail,
                            "onUpdate:checked": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedSecao7.possuiPcnEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.possuiPcnEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe um Plano Formal de Continuidade de Negócios (PCN)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiPcn')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.possuiPcnVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.possuiPcn,
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.computedSecao7.possuiPcn = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.possuiPcnVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.possuiPcn,
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.computedSecao7.possuiPcn = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiPcn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiPcn), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.possuiPcnVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.possuiPcnObservacoesVisivel,
                              "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedSecao7.possuiPcnObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.possuiPcnObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.possuiPcnObservacoes,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedSecao7.possuiPcnObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel,
                        "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteEnviarEmail,
                            "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe um Plano Formal de Trabalho de Permissão de trabalho a quente? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiPlanoFormalPermissaoTrabalhoQuente')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuente,
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuente = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuente,
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuente = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiPlanoFormalPermissaoTrabalhoQuente)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiPlanoFormalPermissaoTrabalhoQuente), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteObservacoesVisivel,
                              "onUpdate:checked": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteObservacoes,
                            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao7.possuiPlanoFormalPermissaoTrabalhoQuenteObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.estimativaImpactoFinanceiroVisivel,
                        "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao7.estimativaImpactoFinanceiroVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.estimativaImpactoFinanceiroVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.estimativaImpactoFinanceiroEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.estimativaImpactoFinanceiroEnviarEmail,
                            "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedSecao7.estimativaImpactoFinanceiroEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.estimativaImpactoFinanceiroEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual é a estimativa de impacto financeiro decorrente de lucros cessantes nos cenários de interrupção de: "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('estimativaImpactoFinanceiro')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.estimativaImpactoFinanceiro)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.ManualPreenchimentoInspecao.estimativaImpactoFinanceiro), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao7.estimativaImpactoFinanceiroVisivel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedSecao7.impactoFinanceiroLucrosCessantes6m) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_42), [
                            [_vModelText, _ctx.computedSecao7.impactoFinanceiroLucrosCessantes6m]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedSecao7.impactoFinanceiroLucrosCessantes12m) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_45), [
                            [_vModelText, _ctx.computedSecao7.impactoFinanceiroLucrosCessantes12m]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.estimativaImpactoFinanceiroVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.estimativaImpactoFinanceiroObservacoesVisivel,
                              "onUpdate:checked": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedSecao7.estimativaImpactoFinanceiroObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.estimativaImpactoFinanceiroObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.estimativaImpactoFinanceiroObservacoes,
                            "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedSecao7.estimativaImpactoFinanceiroObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.valorEstoqueMateriaPrimaVisivel,
                        "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrimaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.valorEstoqueMateriaPrimaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.valorEstoqueMateriaPrimaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.valorEstoqueMateriaPrimaEnviarEmail,
                            "onUpdate:checked": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrimaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.valorEstoqueMateriaPrimaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Valor estimado de produtos em estoque. matéria prima para processo produtivo? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[45] || (_cache[45] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('valorEstoqueMateriaPrima')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.valorEstoqueMateriaPrima)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.ManualPreenchimentoInspecao.valorEstoqueMateriaPrima), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao7.valorEstoqueMateriaPrimaVisivel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.computedSecao7.valorEstoqueMateriaPrima,
                            "onUpdate:valor": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrima) = $event)),
                            monetario: true,
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createVNode(_component_selecionar_data, {
                            "data-selecionada": _ctx.computedSecao7.valorEstoqueMateriaPrimaData,
                            "onUpdate:dataSelecionada": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrimaData) = $event))
                          }, null, 8, ["data-selecionada"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.valorEstoqueMateriaPrimaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.valorEstoqueMateriaPrimaObservacoesVisivel,
                              "onUpdate:checked": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrimaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.valorEstoqueMateriaPrimaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.valorEstoqueMateriaPrimaObservacoes,
                            "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueMateriaPrimaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("label", _hoisted_62, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.valorEstoqueProdutoAcabadoVisivel,
                        "onUpdate:checked": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.valorEstoqueProdutoAcabadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.valorEstoqueProdutoAcabadoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.valorEstoqueProdutoAcabadoEnviarEmail,
                            "onUpdate:checked": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao7.valorEstoqueProdutoAcabadoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Valor estimado dos produtos acabados em estoque "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[52] || (_cache[52] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('valorEstoqueProdutoAcabado')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.valorEstoqueProdutoAcabado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.ManualPreenchimentoInspecao.valorEstoqueProdutoAcabado), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoVisivel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _hoisted_67,
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.computedSecao7.valorEstoqueProdutoAcabado,
                            "onUpdate:valor": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabado) = $event)),
                            monetario: true,
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createVNode(_component_selecionar_data, {
                            "data-selecionada": _ctx.computedSecao7.valorEstoqueProdutoAcabadoData,
                            "onUpdate:dataSelecionada": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoData) = $event))
                          }, null, 8, ["data-selecionada"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.valorEstoqueProdutoAcabadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.valorEstoqueProdutoAcabadoObservacoesVisivel,
                              "onUpdate:checked": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.valorEstoqueProdutoAcabadoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.valorEstoqueProdutoAcabadoObservacoes,
                            "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.computedSecao7.valorEstoqueProdutoAcabadoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel,
                        "onUpdate:checked": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.houveSinistrosVigenciaAtualEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.houveSinistrosVigenciaAtualEnviarEmail,
                            "onUpdate:checked": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.computedSecao7.houveSinistrosVigenciaAtualEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao7.houveSinistrosVigenciaAtualEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Houve sinistros durante a vigência do seguro atual? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('houveSinistrosVigenciaAtual')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.houveSinistrosVigenciaAtual,
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.computedSecao7.houveSinistrosVigenciaAtual = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.houveSinistrosVigenciaAtual,
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.computedSecao7.houveSinistrosVigenciaAtual = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.houveSinistrosVigenciaAtual)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(_ctx.ManualPreenchimentoInspecao.houveSinistrosVigenciaAtual), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.houveSinistrosVigenciaAtualVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("label", _hoisted_77, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.houveSinistrosVigenciaAtualObservacoesVisivel,
                              "onUpdate:checked": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedSecao7.houveSinistrosVigenciaAtualObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.houveSinistrosVigenciaAtualObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.houveSinistrosVigenciaAtualObservacoes,
                            "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.computedSecao7.houveSinistrosVigenciaAtualObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel,
                        "onUpdate:checked": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosEnviarEmail,
                            "onUpdate:checked": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe histórico de vendavais, granizo ou eventos climáticos severos nos últimos 3 anos? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[66] || (_cache[66] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos,
                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos,
                        onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.ManualPreenchimentoInspecao.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3Anos), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("label", _hoisted_83, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosObservacoesVisivel,
                              "onUpdate:checked": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosObservacoes,
                            "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.computedSecao7.historicoVendavaisGranizoEventosClimaticosSeverosUltimos3AnosObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("label", _hoisted_86, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.vizinhosApresentamRiscoVisivel,
                        "onUpdate:checked": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.computedSecao7.vizinhosApresentamRiscoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.vizinhosApresentamRiscoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.vizinhosApresentamRiscoEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.vizinhosApresentamRiscoEnviarEmail,
                            "onUpdate:checked": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.computedSecao7.vizinhosApresentamRiscoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao7.vizinhosApresentamRiscoEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existem vizinhos que apresentem riscos à operação? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[73] || (_cache[73] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('vizinhosApresentamRisco')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao7.vizinhosApresentamRiscoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao7.vizinhosApresentamRisco,
                        onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.computedSecao7.vizinhosApresentamRisco = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao7.vizinhosApresentamRiscoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao7.vizinhosApresentamRisco,
                        onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.computedSecao7.vizinhosApresentamRisco = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.vizinhosApresentamRisco)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(_ctx.ManualPreenchimentoInspecao.vizinhosApresentamRisco), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao7.vizinhosApresentamRiscoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao7.vizinhosApresentamRiscoObservacoesVisivel,
                              "onUpdate:checked": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.computedSecao7.vizinhosApresentamRiscoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao7.vizinhosApresentamRiscoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao7.vizinhosApresentamRiscoObservacoes,
                            "onUpdate:value": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedSecao7.vizinhosApresentamRiscoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao7.observacoesGeraisVisivel,
                        "onUpdate:checked": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.computedSecao7.observacoesGeraisVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao7.observacoesGeraisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao7.observacoesGeraisEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao7.observacoesGeraisEnviarEmail,
                            "onUpdate:checked": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.computedSecao7.observacoesGeraisEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao7.observacoesGeraisEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Observações gerais da inspeção:")
                ]),
                ((_ctx.computedSecao7.observacoesGeraisVisivel))
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 0,
                      "auto-size": true,
                      value: _ctx.computedSecao7.observacoesGerais,
                      "onUpdate:value": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.computedSecao7.observacoesGerais) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}